import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { BounceLoader } from 'react-spinners';
import Button from '../../common/components/Button';
import { getCopy } from '../../common/lib/copyDefaults';
import { getVerificationLink } from '../../redux/verificationLinkSession';

import '../../../style/index.css';
import './identityVerification.css';

class IdentityVerificationView extends Component {
  static propTypes = { history: PropTypes.object.isRequired };

  constructor(props) {
    super(props);
    this.handleContinueClick = this.handleContinueClick.bind(this);
    this.state = { isContinuing: false };
  }

  componentDidMount() {
    requestAnimationFrame(() => {
      const el = document.getElementById('identity-verification-heading');
      if (el) {
        el.focus();
      }
    });
  }

  handleContinueClick(e) {
    e.preventDefault();
    if (this.state.isContinuing) {
      return;
    }
    this.setState({ isContinuing: true });
    const { history } = this.props;
    const verificationLink = getVerificationLink();
    if (verificationLink) {
      window.location.assign(verificationLink);
    } else {
      history.replace('/register');
    }
  }

  render() {
    const copy = getCopy('/idv/identity-verification');
    const { isContinuing } = this.state;

    return (
      <div className="identity-verification row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          <div className="identity-verification__body">
            <h1
              id="identity-verification-heading"
              tabIndex={-1}
              className="identity-verification__title"
            >
              {copy.header}
            </h1>
            <p className="identity-verification__description">{copy.body}</p>
            <ol className="identity-verification__requirements">
              {copy.requirements.map((requirement) => (
                <li key={requirement} className="identity-verification__requirement">
                  {requirement}
                </li>
              ))}
            </ol>
          </div>
          <div className="identity-verification__card">
            <h2 className="identity-verification__card-heading">{copy.cardHeading}</h2>
            <p className="identity-verification__card-body">{copy.cardBody}</p>
            <div className="identity-verification__button-wrap">
              {isContinuing ? (
                <div className="loading-wrapper">
                  <BounceLoader color="#084267" />
                </div>
              ) : (
                <Button
                  label={copy.continueLabel}
                  onClickFn={this.handleContinueClick}
                  className="nyl-button"
                  id="identity-verification-continue-button"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(IdentityVerificationView);
